import styled from "react-emotion"
import PropTypes from "prop-types"
import { injectGlobal } from "react-emotion"

const Text = styled("p")`
    font-family: ${props => props.theme.fontFamily};
    font-size: ${props => props.theme[props.size || "fontM"]};
    padding: ${props => props.theme[props.padding || "small"]} 0px;
    margin: ${props => props.theme[props.margin || "small"]} 0px;
    color: ${props => props.theme.fontColor};
    ${props =>
        props.inline &&
        `
        display: inline-block;
    `};
    ${props =>
        props.light &&
        `
        color: ${props.theme.lightFontColor};
    `};
`
injectGlobal`
  a > ${Text} {
    color: inherit;
  }
`

Text.propTypes = {
    padding: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    margin: PropTypes.oneOf(["xsmall", "small", "medium", "large", "xlarge", "none"]),
    size: PropTypes.oneOf(["fontS", "fontM", "fontL", "fontXL"]),
    inline: PropTypes.bool,
    light: PropTypes.bool,
}

Text.displayName = "Text"
export default Text



// WEBPACK FOOTER //
// ./src/ui/components/Text.js